module.exports = __webpack_public_path__ + "static/media/available-calls.7af1c485.svg";